export default function ReviewFooterStatus({
  selectedCount,
  missingGroundCount,
  onShowMissing,
  needsNote,
  note,
  onNoteChange,
}: {
  selectedCount: number;
  missingGroundCount: number;
  /** Scroll the list to the first item that still needs a ground. */
  onShowMissing: () => void;
  needsNote: boolean;
  note: string;
  onNoteChange: (value: string) => void;
}) {
  return (
    <div className="min-w-0 flex-1">
      <p className="text-sm text-gray-600">
        <span className="font-semibold text-gray-900 tabular-nums">
          {selectedCount}
        </span>{' '}
        {selectedCount === 1 ? 'item' : 'items'} will be removed.
        {missingGroundCount > 0 && (
          <button
            type="button"
            onClick={onShowMissing}
            title="Show in the list"
            className="ml-1 rounded font-semibold text-amber-700 underline decoration-dotted underline-offset-2 hover:text-amber-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
          >
            {missingGroundCount} still{' '}
            {missingGroundCount === 1 ? 'needs' : 'need'} a ground.
          </button>
        )}
      </p>
      {needsNote && (
        <div className="mt-2">
          <label className="block text-xs font-semibold text-gray-600">
            Public interest consideration
            <span className="ml-1 font-normal text-gray-400">
              Required for grounds under section 7(2).
            </span>
          </label>
          <input
            type="text"
            value={note}
            onChange={(event) => onNoteChange(event.target.value)}
            placeholder="Why withholding outweighs the public interest in release"
            className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-1.5 text-sm focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500"
          />
        </div>
      )}
    </div>
  );
}
